import React, { useState } from 'react';
import logo from '../../assets/images/logo.png';
import auth from '../../assets/images/authentication/img-auth-sideimg.jpg';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { postData } from '../Services/api';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

const Register = () => {
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();

    const toggleVisibility = () => {
        setShowPassword(!showPassword);
    };

    const initialValues = {
        name: '',
        email: '',
        mobile: '',
        company_name: '',
        password: ''
    };

    const validationSchema = Yup.object({
        name: Yup.string().required('Name is required'),
        email: Yup.string()
            .email('Invalid email')
            .required('Email is required'),
        company_name: Yup.string()
            .required('Company name is required'),
        mobile: Yup.string()
            .required('Company name is required'),
        password: Yup.string()
            .min(6, 'Min 6 characters')
            .required('Password required')
    });

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            const res = await postData('/auth/admin-register', values);

            if (res?.status) {
                toast.success(res.message || "Registered successfully");
                resetForm();
                navigate('/login');
            } else {
                toast.error(res?.message || "Registration failed");
            }

        } catch (error) {
            const msg =
                error?.response?.data?.message ||
                "Server error";

            toast.error(msg);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="auth-main">
            <div className="auth-wrapper v2">

                <div className="auth-sidecontent">
                    <img src={auth} alt="img" className="img-fluid img-auth-side" />
                </div>

                <div className="auth-form">
                    <div className="card my-5">
                        <div className="card-body">

                            <div className="text-center mb-4">
                                <img src={logo} width={100} alt="logo" />
                            </div>

                            <h4 className="text-center mb-3">Create Account</h4>

                            <Formik
                                initialValues={initialValues}
                                validationSchema={validationSchema}
                                onSubmit={handleSubmit}
                            >
                                {({ isSubmitting }) => (
                                    <Form>

                                        <Field
                                            name="name"
                                            className="form-control mb-2"
                                            placeholder="Full Name"
                                        />
                                        <ErrorMessage name="name" component="div" className="text-danger" />

                                        <Field
                                            name="company_name"
                                            className="form-control mb-2"
                                            placeholder="Company Name"
                                        />
                                        <ErrorMessage name="company_name" component="div" className="text-danger" />


                                        <Field
                                            type="number"
                                            name="mobile"
                                            className="form-control mb-2"
                                            placeholder="Mobile Number"
                                        />
                                        <ErrorMessage name="mobile" component="div" className="text-danger" />


                                        <Field
                                            type="email"
                                            name="email"
                                            className="form-control mb-2"
                                            placeholder="Email"
                                        />
                                        <ErrorMessage name="email" component="div" className="text-danger" />

                                        <div className="input-group mb-2">
                                            <Field
                                                type={showPassword ? "text" : "password"}
                                                name="password"
                                                className="form-control"
                                                placeholder="Password"
                                            />
                                            <span
                                                className="input-group-text"
                                                onClick={toggleVisibility}
                                                style={{ cursor: "pointer" }}
                                            >
                                                👁
                                            </span>
                                        </div>
                                        <ErrorMessage name="password" component="div" className="text-danger" />

                                        <button
                                            type="submit"
                                            className="btn btn-primary w-100 mt-3"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? "Please wait..." : "Register"}
                                        </button>

                                        <p className="text-center mt-3">
                                            Already have account? <Link to="/login">Login</Link>
                                        </p>

                                    </Form>
                                )}
                            </Formik>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Register;
